<template>
  <div class="d-flex flex-column align-items-center">
    <div class="d-flex flex-column col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 container" :style="backgroundImage">
      <div class="router-view-container">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {setBrandConfig} from "./functions/setBrandConfig";

export default {
  computed: {
    ...mapState(['brandConfig']),
    backgroundImage() {
      return {
        backgroundImage: `url(${require(`@/brand/${this.brandConfig.brand}/background-image.png`)})`,
      }
    }
  },
  methods: {
    setFavicon() {
      
    },
  },
  beforeMount() {
    setBrandConfig();
    this.setFavicon();
  }
}
</script>
<style>
@font-face {
  font-family: 'Poppins Regular';
  src: url('~@/assets/fonts/Poppins-Regular.ttf') format('truetype');
  font-weight: 100 900;
  font-style: normal;
}

.container {
  position: fixed;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  font-family: "Poppins Regular", sans-serif;
}

.router-view-container {
  position: relative;
  top: 34vh;
}

</style>
